import React, { FC, ReactNode } from 'react';
import { Box, Container, Grid } from '@material-ui/core';
import { ExpertiseCard } from 'components/atoms';
import {
  ConstructionOrangeIcon,
  ConsultingBusinessServicesIcon,
  DataServicesIcon,
  EnergyOrangeIcon,
  EngineeringOrangeIcon,
  FulfillmentServicesIcon,
  OilGasIcon,
  PowerDeliveryIcon,
  TechnologyDeploymentOrangeIcon,
  WaterServiceIcon,
  WirelessOrangeIcon,
  WirelineExpertiseIcon,
} from 'svgs/expertise';
import {
  ConstructionCardImage,
  EngineeringCardImage,
  oilGas,
  powerDelivery,
  renewableEnergy,
  TechnologyDeploymentCardImage,
  WirelessCardImage,
  wireline,
} from 'images/expertise';

import { waterSmall } from 'images/expertise/water-service';
import { businessTeam } from '../../images/expertise/consulting-business-services';
import { fulfillmentService } from '../../images/expertise/fulfillment-services';
import { expertiseDataCenters } from '../../images/expertise/data-centers-capabilities';

const CardsSection: FC = () => {
  const data: Array<{
    title: string;
    text: string;
    icon: ReactNode;
    image: string;
    link: string;
    mainPageLink?: string;
  }> = [
    {
      title: 'Engineering',
      text: 'Making any project a success',
      icon: <EngineeringOrangeIcon />,
      image: EngineeringCardImage,
      link: '/expertise/engineering',
    },
    {
      title: 'Wireless',
      text: 'Bringing people together',
      icon: <WirelessOrangeIcon />,
      image: WirelessCardImage,
      link: 'expertise/wireless',
    },
    {
      title: 'Renewable Energy',
      text: 'Keeping the lights on',
      icon: <EnergyOrangeIcon />,
      image: renewableEnergy,
      link: '/expertise/energy',
    },
    {
      title: 'Construction',
      text: 'Building a better tomorrow',
      icon: <ConstructionOrangeIcon />,
      image: ConstructionCardImage,
      link: '/expertise/construction',
    },
    {
      title: 'Technology Deployment',
      text: 'Integrating modern innovations',
      icon: <TechnologyDeploymentOrangeIcon />,
      image: TechnologyDeploymentCardImage,
      link: '/expertise/technology-deployment/noc',
    },
    {
      title: 'Water Utilities',
      text: 'Delivering and Maintaining Water Systems',
      icon: <WaterServiceIcon />,
      image: waterSmall,
      link: '/expertise/water-utility-services',
      mainPageLink: '/water-utility-services',
    },
    {
      title: 'Consulting & Business Services',
      text: 'Empowering and Guiding Business Success',
      icon: <ConsultingBusinessServicesIcon />,
      image: businessTeam,
      link: '/expertise/consulting-business-services',
    },
    {
      title: 'Fulfillment Services',
      text: 'Delivering connectivity through installation and restoration',
      icon: <FulfillmentServicesIcon />,
      image: fulfillmentService,
      link: '/expertise/fulfillment-services',
      mainPageLink: '/fulfillment-services',
    },
    {
      title: 'Wireline',
      text: 'Connecting communities with reliable networks',
      icon: <WirelineExpertiseIcon />,
      image: wireline,
      link: '/expertise/wireline',
      mainPageLink: '/wireline-construction',
    },
    // {
    //   title: 'Oil & Gas',
    //   text: 'Powering energy with efficient pipelines',
    //   icon: <OilGasIcon />,
    //   image: oilGas,
    //   link: '/expertise/oil-gas',
    // },

    {
      title: 'Power Delivery',
      text: 'Transforming energy distribution systems',
      icon: <PowerDeliveryIcon />,
      image: powerDelivery,
      link: '/expertise/power-delivery',
    },
    {
      title: 'Data Centers Capabilities',
      text: 'Powering digital infrastructure seamlessly',
      icon: <DataServicesIcon />,
      image: expertiseDataCenters,
      link: '/expertise/data-centers-capabilities',
      mainPageLink: '/data-centers-capabilities',
    },
  ];

  return (
    <Box>
      <Container fixed>
        <Grid container spacing={6}>
          {data.map((card, index) => (
            <Grid
              item
              // lg={index === array.length - 2 || index === array.length - 1 ? 6 : 4}
              // md={index === array.length - 1 ? 12 : 6}
              xs={12}
              sm={12}
              md={6}
              lg={4}
              key={index}
              data-aos="fade-up"
            >
              <ExpertiseCard
                title={card.title}
                text={card.text}
                icon={card.icon}
                image={card.image}
                link={card.link}
                data-aos="fade-up"
                mainPageLink={card?.mainPageLink}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default CardsSection;
